import { render } from "./topSearch.vue?vue&type=template&id=b89cdab8&scoped=true"
import script from "./topSearch.vue?vue&type=script&lang=js"
export * from "./topSearch.vue?vue&type=script&lang=js"

import "./topSearch.vue?vue&type=style&index=0&id=b89cdab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89cdab8"]])

export default __exports__